import React, { CSSProperties, useEffect } from 'react';
import Widget from '../';
import { WidgetProps } from "./types";
import styles from './styles.module.scss';
import { useLocation } from 'react-router';
import { images } from '../../../../assets/image';

const SliderWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
    const {
        data,
    } = props.widgetParams;

    const defaultPaddings: CSSProperties = {
        marginLeft: 5,
        marginRight: 5,
        marginTop: 5,
        marginBottom: 5,
      };
    const queryParams = new URLSearchParams(useLocation().search);
    const paramLang = queryParams.get('lang');

    const widgetsData  = () => {
        if(data) {
            return (JSON.parse(data) as any[]);
        } else {
            return [];
        }
    };
   
 
    const columnWidth = () => {
        return `${(+props.widgetParams.widgetWidth / 24) * 100}%`
    };
    const isCarouselWidget = () => {
        return `${props.widgetParams.isCarousel}` === 'true';
    };
    const isShowAction = () => {
        return `${props.widgetParams.showAction}` === 'true';
    };
    const dir = () => {
        if(paramLang === 'ar') {
            return styles.directionRtl;
        } else {
            return styles.directionLtr;   
        }
    };
    const classes = (...arr: string[]) => {
        return arr.join(" ");
    };
    const animateToFocusedWidget = (id: string) => {
        const element = document.getElementById('slideContainer');
        if(element) {
          const containerWidth = element?.getBoundingClientRect().width;
          let widgetWidth = +containerWidth / (24 / +props.widgetParams.widgetWidth);
          const widgetNumber = widgetsData().findIndex(w => w.widgetInstanceId == id);
          if(paramLang === 'ar') {
              widgetWidth *= -1;
          }
          element.scrollTo({
              left: (+widgetWidth * widgetNumber),
              top: 0,
              behavior: 'smooth'
          });
        }
      };
    const sliderDots = () => {
        return (
            <>
            <div className={styles.dotsContainer}>
                {
                widgetsData().map(wd => <div className={styles.dotItem} onClick={() => animateToFocusedWidget(wd.widgetInstanceId)}></div> )
                }
            </div>
            </>
        );
      };
    
    return(
    <div className={classes(styles.sliderWidger , dir())}>
        {
            isShowAction()  &&
            <div className={styles.titleContainer}>
                <span className={styles.title}>{props.widgetParams.title}</span>
                {
                 paramLang === 'en' ?
                    <span className={styles.more}>More {images.arrowRight}</span>:
                    <span className={styles.more}>المذيد {images.arrowLeft}</span>
                }
            </div>
        }
        {isCarouselWidget() && sliderDots()}
        <div className={styles.scrollItems} id={'slideContainer'}>
        {
            widgetsData().map((item: any) => (
            <div
                key={item.widgetInstanceId}
                className={styles.col}
                id={item.widgetInstanceId}
                style={{minWidth: columnWidth()}}
            >
                <Widget
                    widget={item}
                    defaultPaddings={defaultPaddings}
                />
            </div>
            ))
        }
        </div>
    </div>
    )
};

export default SliderWidget;